import React from 'react';
import { motion } from 'framer-motion';
export function RegionalFocus() {
  return <section className="py-20 bg-cream-dark overflow-hidden" data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-140">
          {/* Left Side: Map Silhouettes */}
          <div className="relative h-[400px] md:h-[500px] w-full flex items-center justify-center bg-white rounded-card shadow-sm border border-gray-100 p-8" data-id="element-141">
            <div className="relative w-full h-full max-w-md mx-auto" data-id="element-142">
              {/* Abstract Representation of West Africa Focus */}
              <svg viewBox="0 0 400 400" className="w-full h-full drop-shadow-xl" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-143">
                {/* Nigeria Silhouette (Abstracted) */}
                <motion.path d="M180,150 C220,140 280,130 310,160 C340,190 350,250 320,290 C290,330 220,340 180,310 C140,280 130,220 150,180 Z" fill="#002147" fillOpacity="0.9" initial={{
                opacity: 0,
                scale: 0.9
              }} whileInView={{
                opacity: 1,
                scale: 1
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.8
              }} data-id="element-144" />

                {/* Ghana Silhouette (Abstracted) */}
                <motion.path d="M80,200 C110,190 130,210 140,240 C150,270 130,310 100,320 C70,330 50,290 60,250 Z" fill="#002147" fillOpacity="0.7" initial={{
                opacity: 0,
                scale: 0.9
              }} whileInView={{
                opacity: 1,
                scale: 1
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.8,
                delay: 0.2
              }} data-id="element-145" />

                {/* Lagos Dot */}
                <g transform="translate(190, 290)" data-id="element-146">
                  <motion.circle cx="0" cy="0" r="6" fill="#AF9B60" animate={{
                  scale: [1, 1.5, 1],
                  opacity: [1, 0.5, 1]
                }} transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} data-id="element-147" />
                  <circle cx="0" cy="0" r="3" fill="#FCFBF7" data-id="element-148" />
                  <text x="12" y="4" className="font-sans text-xs font-bold fill-navy bg-white" data-id="element-149">
                    Lagos
                  </text>
                </g>

                {/* Accra Dot */}
                <g transform="translate(100, 300)" data-id="element-150">
                  <motion.circle cx="0" cy="0" r="6" fill="#AF9B60" animate={{
                  scale: [1, 1.5, 1],
                  opacity: [1, 0.5, 1]
                }} transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: 'easeInOut',
                  delay: 1
                }} data-id="element-151" />
                  <circle cx="0" cy="0" r="3" fill="#FCFBF7" data-id="element-152" />
                  <text x="-40" y="4" className="font-sans text-xs font-bold fill-navy" data-id="element-153">
                    Accra
                  </text>
                </g>
              </svg>
            </div>
          </div>

          {/* Right Side: Content */}
          <div data-id="element-154">
            <span className="inline-block font-sans font-bold text-xs uppercase tracking-widest text-gold mb-4" data-id="element-155">
              Regional Expertise
            </span>
            <h2 className="font-serif text-4xl md:text-5xl text-navy font-bold mb-6 leading-tight" data-id="element-156">
              The African Opportunity
            </h2>
            <p className="font-sans text-lg text-text-muted leading-relaxed mb-10" data-id="element-157">
              With GDP growth projections exceeding 6% across West Africa by
              2026, Nigeria and Ghana represent the most dynamic market entry
              points for US enterprises. Emma Kay Consulting provides the
              on-the-ground intelligence and policy expertise that transforms
              market complexity into competitive advantage.
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-8 pt-8 border-t border-gray-200" data-id="element-158">
              <div data-id="element-159">
                <div className="font-serif text-4xl md:text-5xl text-navy font-bold mb-2" data-id="element-160">
                  $1.2T
                </div>
                <div className="font-sans text-sm font-semibold text-gray-500 uppercase tracking-wide" data-id="element-161">
                  Combined GDP
                </div>
              </div>
              <div data-id="element-162">
                <div className="font-serif text-4xl md:text-5xl text-navy font-bold mb-2" data-id="element-163">
                  450M+
                </div>
                <div className="font-sans text-sm font-semibold text-gray-500 uppercase tracking-wide" data-id="element-164">
                  Consumer Market
                </div>
              </div>
              <div data-id="element-165">
                <div className="font-serif text-4xl md:text-5xl text-navy font-bold mb-2" data-id="element-166">
                  6.2%
                </div>
                <div className="font-sans text-sm font-semibold text-gray-500 uppercase tracking-wide" data-id="element-167">
                  Projected Growth
                </div>
              </div>
              <div data-id="element-168">
                <div className="font-serif text-4xl md:text-5xl text-navy font-bold mb-2" data-id="element-169">
                  15+
                </div>
                <div className="font-sans text-sm font-semibold text-gray-500 uppercase tracking-wide" data-id="element-170">
                  Years Experience
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}